import { TabView } from "@grindex-client/components/Tabs/TabView.class";
import { baseLink } from "@grindex-common/helpers/baseLink";

function init($views) {
	const ROUTES = {
		"/": "overview",
		"/schedule/": "schedule",
		"/brands/": "brands",
		"/speakers/": "speakers",
		"/faq/": "faq",
		"/register/": "register",
		"*default": "overview",
	};

	$views.forEach(($productTab) => {
		const tabView = new TabView(baseLink.getBaseLinkWithoutSegments(window.config.advancedEvent.tabs), ROUTES, $productTab);

		tabView.init();
	});
}

export default {
	view: "advancedEventTab",
	init,
};
